import FixtureDescription from "../../fixture/FixtureDescription";
import { FixtureDescriptions } from "../../fixture/FixtureDescriptions";
import MersenneTwister from "../../math/MersenneTwister";

export default class TileDecoratorTheme {
    /**
     * @param {Array.<string>} fixtureNames 
     * @param {Array.<string>} colorNames
     * @param {number} probabilityDenominator A value of 2 means that (1/2) tiles will be decorated. 3 means 1/3 tiles.
     */
    constructor(fixtureNames, colorNames, probabilityDenominator) {
        /**
         * @private
         * @constant
         * @type {Array.<string>}
         */
        this.fixtureNames = fixtureNames;
        /**
         * @private
         * @constant
         * @type {Array.<string>}
         */
        this.colorNames = colorNames;

        /**
         * @private
         * @constant
         * @type {number}
         */
        this.probabilityDenominator = probabilityDenominator;
    }

    /**
     * @param {MersenneTwister} rng 
     * @returns {FixtureDescription}
     */
    getFixtureDescription(rng) {
        if (this.fixtureNames.length === 0 || this.colorNames.length === 0) {
            return null;
        }

        const index = rng.randomInt(this.fixtureNames.length * this.probabilityDenominator);  // Only decorate a fraction of the tiles
        if (index >= this.fixtureNames.length) {
            return null;
        }

        const fixtureName = this.fixtureNames[index];

        const color = this.colorNames.length === 1 ? this.colorNames[0] : this.colorNames[rng.randomInt(this.colorNames.length)];

        return FixtureDescriptions.getDescription(fixtureName, color);

    }
    
}